import React from "react";
import { ToastContainer, toast, Flip } from "react-toastify";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { createTrainerProfDetails } from "../../actions/";
import "react-toastify/dist/ReactToastify.css";
import { firebase } from "./../firebase";
import { toastConfig } from "../Custom/ToastConfig";
import moment from "moment";
import CustomSpinner from "../Custom/spinner";
import Success from "./Success";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { functions_for_users } from "../../function_constant";
import { updateStep, userLoginDetails } from "../../actions/index";


const FA = require("react-fontawesome");

class TrainerExperience extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      experience: props.trainer.experience,
      aadharURL: "",
      panURL: "",
      photoURL: "",
      certificateURL: "",
      loading: false,
      success: false
    };
  }

  handleInputChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  generatePassword() {
    return (
      Math.random()
        .toString(36)
        .slice(2) +
      Math.random()
        .toString(36)
        .slice(2)
    );
  }

  handleSubmit() {
    var self = this;
    let add = this.props.trainer;
    add.password = this.generatePassword();
    add.token = "isTrainer";
    add.status = "P";

    if (this.state.experience) {
      self.setState({
        loading: true
      });
      
      // console.log(add);
      this.postData('https://d1dgpoid6t01jm.cloudfront.net/api/v1/trainers', add)
        .then(user => {
          if (user.statusCode != 400) {
           
            this.state.success = true;
            this.props.updateStep(6);
            
            self.setState({
              loading: false
            });
            toast(
              "Registered successfully",
              toastConfig
            );
          } else {
            self.setState({
              loading: false
            });
            toast(
              user.message,
              toastConfig
            );
          }
        })
        .catch(error => {
          self.setState({
            loading: false
          });
          toast(error.message, toastConfig);
        });
    } else {
      self.setState({
        loading: false
      });
      toast("Put NA for no experience", toastConfig);
    }
  }

  postData(url = ``, data) {
    return new Promise(function(resolve, reject) {
      fetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify(data) // body data type must match "Content-Type" header
      })
        .then(response => resolve(response.json()))
        .catch(err => {
          reject(err);
        }); // parses response to JSON
    });
  }

  handleReset = () => {
    this.setState({
      experience: ""
    });
  };

  render() {
    return (
      <div>
        <ValidatorForm onSubmit={this.handleSubmit}>
          <div className="form-group">
            <TextValidator
              type="text"
              placeholder="Experience *"
              className="form-control"
              validators={["required"]}
              name="experience"
              errorMessages={"This field is mandatory! "}
              onChange={this.handleInputChange}
              value={this.state.experience}
            />
          </div>

          <div className="iconContainerRow">
            <FA
              name="arrow-left"
              onClick={() => this.props.previousPage()}
              className="iconPrev"
            />
            <FA
              name="arrow-right"
              onClick={e => this.handleSubmit(e)}
              className="iconNext"
            />
          </div>
          <ToastContainer transition={Flip} />
        </ValidatorForm>
        <ToastContainer transition={Flip} />
        {this.state.loading ? (
          <CustomSpinner
            spinnerVal={true}
            val="Creating Your Profile ! It may take a while "
          />
        ) : null}
        {this.state.success ? <Success /> : null}
      </div>
    );
  }
}
const mapStateToProps = State => {
  return { trainer: State.trainerInfo };
};

const mapDispatchToProps = dispatch => {
  return {
    updateStep: step => {
      dispatch(updateStep(step));
    },
    onAddPost: prof => {
      dispatch(createTrainerProfDetails(prof));
    }
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TrainerExperience)
);
